const moment = require('moment');

module.exports.getDates = function (periodo, fechaSeleccionada) {
  const fechas = { fechaIni: 0, fechaFin: 0 };
  switch (periodo) {
    case 'W':
      fechas.fechaIni = moment(fechaSeleccionada)
        .startOf('isoWeek')
        .add(-2, 'day')
        .valueOf();
      fechas.fechaFin = moment(fechaSeleccionada)
        .startOf('isoWeek')
        .add(-2, 'day')
        .add(1, 'week')
        .add(-1, 'second')
        .valueOf();
      break;
    case 'M':
      fechas.fechaIni = moment(new Date(
        fechaSeleccionada.getFullYear(),
        fechaSeleccionada.getMonth(),
        1,
      )).valueOf();
      fechas.fechaFin = moment(new Date(
        fechaSeleccionada.getFullYear(),
        fechaSeleccionada.getMonth(),
        0,
      ))
        .add(1, 'month')
        .valueOf();
      break;
    case 'A':
      var firstday = new Date(
        fechaSeleccionada.getFullYear(),
        fechaSeleccionada.getMonth(),
        1,
      );
      fechas.fechaIni = moment(firstday).valueOf();
      fechas.fechaFin = moment(fechaSeleccionada)
        .add(1, 'day')
        .add(-1, 'second')
        .valueOf();
      break;
    case 'D':
      fechaSeleccionada.setHours(0, 0, 0, 0);
      fechas.fechaIni = moment(fechaSeleccionada).valueOf();
      fechaSeleccionada.setHours(23, 59, 59, 999);
      fechas.fechaFin = moment(fechaSeleccionada).valueOf();
      break;
  }
  return fechas;
};
module.exports.dateKeys = {
  D: 'days',
  W: 'weeks',
  Y: 'years',
  M: 'months',
};
